import { BROADCAST_NOTIFICATION_TYPE } from "@/entities/broadcast-notification";
import { useEventBusListener } from "@/modules/event-bus";

import { useJobModuleActionFailed } from "./job-module-action-failed.hook";

const JobModuleActionFailed = () => {
  const { runAction } = useJobModuleActionFailed();

  useEventBusListener(BROADCAST_NOTIFICATION_TYPE.JOB_MODULE_FAILED, runAction);

  return <></>;
};

export default JobModuleActionFailed;
